import { useEffect, useState } from 'react'
import { AllowedAccess } from 'react-permission-role'
import { useSelector } from 'react-redux'
import Select from 'react-select'

import Swal from 'sweetalert2'
import { Button, Card, CardBody, CardHeader, CardTitle, Col, Form, FormGroup, Input, Row } from 'reactstrap'


import { useForm } from "../../../../hooks/";

import { FormGarantiaDetalleBienInmueble } from './FormGarantiaDetalleBienInmueble'
import { FormGarantiaDetalleVehiculo } from './FormGarantiaDetalleVehiculo'


// Estado inicial para el formulario (se usa en el Hook de useForm)
const garantiaFormFields = {
    idgarantia: '',
    idcliente: '',
    fecha_recepcion: '',
    tipo_garantia: '',
    descripcion_corta: '',
    descripcion_larga: '',
    valor_garantia: '',

    //DETALLES PARA VEHICULOS
    placa: '',
    color: '',
    modelo: '',
    marca: '',
}

const FormGarantia = ( props ) => {

  // Hook: Para disponer la información del usuario loggeado
  const { user } = useSelector(state => state.auth)

  // Custom Hook: Para manejar inputs del formulario
  const { idgarantia, idcliente, fecha_recepcion, tipo_garantia, descripcion_corta, descripcion_larga, valor_garantia,
    placa, color, modelo, marca, elementResetFlag, onInputChange: onInputChange, onResetForm: onResetForm, setFormState: setFormState } = useForm( garantiaFormFields );

  // Se recuperan las props del componente
  const { 

    // datos (listados, individuales)
    garantiaSelected,

    //clientes para select
    clientes,

    // HandleClicks
    handleClickMostrarForm, 
    
    // Funciones
    setGarantiaSelected,
    listarGarantias,
    createGarantia,
    updateGarantia,

    //Función para registrar detalles de filas de Bien Inmueble
    createDetalleGarantiaBienInmueble,

    //Función para registrar detalles de vehículo
    createDetalleVehiculo,

    //Funciones para eliminar detalles de garantias
    deleteDetalleVehiculo,

    //Detalle de Bien Inmueble
    listarDetalleBienInmueble,
    setDetalleBienInmueble,
    detalleBienInmueble,
    deleteUnSoloDetalleBienInmueble

  } = props

  // Se settea la información en donde corresponde
  useEffect(() => {
    // Determina si hay un registro seleccionado para editar o es una inserción
    if (garantiaSelected.idgarantia > 0) {

      setFormState(prevState => ({
        ...prevState,
        idgarantia: garantiaSelected.idgarantia || '', // Valor predeterminado si es indefinido
        idcliente: garantiaSelected.idcliente || '', // Valor predeterminado si es indefinido
        fecha_recepcion: garantiaSelected.fecha_recepcion || '', // Valor predeterminado si es indefinido
        tipo_garantia: garantiaSelected.tipo_garantia || '', // Valor predeterminado si es indefinido
        descripcion_corta: garantiaSelected.descripcion_corta || '', // Valor predeterminado si es indefinido
        descripcion_larga: garantiaSelected.descripcion_larga || '', // Valor predeterminado si es indefinido
        valor_garantia: garantiaSelected.valor_garantia || '', // Valor predeterminado si es indefinido

        //VALORES PARA FILAS DE BIENES INMUEBLES

        //VALORES PARA DETALLE DE VEHICULOS
        placa: garantiaSelected.placa || '',
        color: garantiaSelected.color || '',
        modelo: garantiaSelected.modelo || '',
        marca: garantiaSelected.marca || '',
      }))

      setTipoGarantiaSelected(garantiaSelected.tipo_garantia);

    }
  }, [garantiaSelected, setFormState]);

  //VALORES DEL INPUT DE TIPOS DE GARANTIA
  const tipoGarantias = [
    { value: 'BIEN INMUEBLE', label: 'BIEN INMUEBLE' },
    { value: 'VEHICULO', label: 'VEHICULO' },
    { value: 'PRENDA', label: 'PRENDA' },
  ];

  //CONSTANTE PARA VALIDAR QUÉ CAMPOS SE MUESTRAN DEPENDIENDO DEL TIPO DE GARANTIA
  const [tipoGarantiaSelected, setTipoGarantiaSelected] = useState('');

  const handleTipoGarantiaChange = (event) => {
    onInputChange({ target: { name: 'tipo_garantia', value: event.value } });
    setTipoGarantiaSelected(event.value);
  };

  // Función para registrar Información
  const insertInformation = () => {
    
    const result = createGarantia({ idcliente: idcliente, fecha_recepcion: fecha_recepcion, tipo_garantia: tipo_garantia, descripcion_corta: descripcion_corta, descripcion_larga: descripcion_larga, valor_garantia: valor_garantia, usuario_creo: user.username, fecha_creo: new Date() })
    result.then(res => {
      if( tipo_garantia === 'BIEN INMUEBLE'){
        Swal.fire({
          title: '¿Desea permanecer en la pantalla de registro?',
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: 'Permanecer',
          cancelButtonText: 'Salir'
        }).then(async result => {
          if (result.isConfirmed) {
            setFormState(prevState => ({
              ...prevState,
              idgarantia: res.insertId || '',
            }))
          }else{
            Swal.fire({
              icon: 'success',
              title: res.msg
            })

            limpiar()
          }
        })
      }else if( tipo_garantia === 'VEHICULO'){
        const result = createDetalleVehiculo({ idgarantia: res.insertId, placa: placa, color: color, modelo: modelo, marca: marca })
        result.then(res => {
          Swal.fire({
            icon: 'success',
            title: res.msg
          })

          limpiar()
        })
        .catch(e => {
          console.log(e)
          Swal.fire({
            icon: 'error',
            title: 'Ocurrio un problema al insertar el detalle del vehículo',
            text: 'Comuniquese con matenimiento'
          })

          limpiar()
        })
      }else{
        Swal.fire({
          icon: 'success',
          title: res.msg
        })

        limpiar()
      }
    })
    .catch(e => {
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Ocurrio un problema al insertar el registro principal',
        text: 'Comuniquese con matenimiento'
      })
      
      limpiar()
    })
  }

  const updateInformation = () => {
    const result = updateGarantia({ idgarantia: idgarantia, idcliente: idcliente, fecha_recepcion: fecha_recepcion, tipo_garantia: tipo_garantia, descripcion_corta: descripcion_corta, descripcion_larga: descripcion_larga, valor_garantia: valor_garantia, usuario_modifico: user.username, fecha_modifico: new Date() })
    result.then(async res => {
      //Funciones para eliminar detalles de garantias
      await deleteDetalleVehiculo({ idgarantia: idgarantia })

      if( tipo_garantia === 'BIEN INMUEBLE'){
        Swal.fire({
          title: '¿Desea permanecer en la pantalla de registro?',
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: 'Permanecer',
          cancelButtonText: 'Salir'
        }).then(async result => {
          if (result.isConfirmed) {
            setFormState(prevState => ({
              ...prevState,
              idgarantia: res.insertId || '',
            }))
          }else{
            Swal.fire({
              icon: 'success',
              title: res.msg
            })

            limpiar()
          }
        })
      }else if( tipo_garantia === 'VEHICULO'){
        const result = createDetalleVehiculo({ idgarantia: idgarantia, placa: placa, color: color, modelo: modelo, marca: marca })
        result.then(res => {
          Swal.fire({
            icon: 'success',
            title: res.msg
          })
        })
        .catch(e => {
          console.log(e)
          Swal.fire({
            icon: 'error',
            title: 'Ocurrio un problema al insertar el detalle del vehículo',
            text: 'Comuniquese con matenimiento'
          })
        })

        limpiar()
      }else{
        Swal.fire({
          icon: 'success',
          title: res.msg
        })

        limpiar()
      }
      
      
    })
    .catch(e => {
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Ocurrio un problema',
        text: 'Comuniquese con matenimiento'
      })
      
      limpiar()
    })
  }

  
  // Acciona el Insert/Update
  const handleSubmitForm = (e) => {
    
    e.preventDefault()
    
    // Determina si hay un registro seleccionado para editar o es una inserción
    if(garantiaSelected.idgarantia > 0){
      updateInformation()
    }else{
      insertInformation()
    }
    
  }

  // Cancela la visualizacion del formulario al darle click al botón "Cancelar"
  const handleClickCancelarForm = () => {
    limpiar()
    console.log("Limpiando")
  }

  // Limpia el formulario
  const limpiar = () => {
    setGarantiaSelected({}) // Limpia el permiso seleccionado para los casos en los que se haya hecho un UPDATE
    handleClickMostrarForm() // Mostrar/Ocultar Formulario
    listarGarantias() // Actualiza el listado de registros
    onResetForm() // Limpia campos del formulario
    setTipoGarantiaSelected('');
    setDetalleBienInmueble([])
  }

  return (
    <AllowedAccess permissions={['ACCESOS', '49_ADMIN']} renderAuthFailed={<p>Error</p>}>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">
                  { (garantiaSelected.idgarantia > 0) ? 'Actualizar Registro' : 'Crear Registro' }
                </CardTitle>
              </CardHeader>
              <CardBody>              
                <Row>
                  <Col sm="12">
                    <Form onSubmit={handleSubmitForm}>
                      <Row>
                        <Col md={6}>
                          <FormGroup>
                                <label htmlFor="idcliente">Cliente</label>
                                <Select
                                    key={`idcliente_${elementResetFlag ? 'reset' : 'normal'}`}
                                    id='idcliente'
                                    name='idcliente'
                                    value={clientes.find(cliente => cliente.value === idcliente)}
                                    onChange={(selectedOption) => {
                                        onInputChange({ target: { name: 'idcliente', value: selectedOption.value } });
                                    }}
                                    options={clientes}
                                    placeholder='Selecciona un Cliente...'
                                    required
                                />
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup>
                                <label htmlFor="tipo_garantia">Tipo de Garantía</label>
                                <Select
                                    key={`tipo_garantia_${elementResetFlag ? 'reset' : 'normal'}`}
                                    id='tipo_garantia'
                                    name='tipo_garantia'
                                    value={tipoGarantias.find(tipoGarantia => tipoGarantia.value === tipo_garantia)}
                                    onChange={(selectedOption) => {
                                        handleTipoGarantiaChange(selectedOption)
                                      }
                                    }
                                    options={tipoGarantias}
                                    placeholder='Selecciona un Tipo de Garantía...'
                                />
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup>
                                <label htmlFor="fecha_recepcion">Fecha de Recepción</label>
                                <Input
                                    id='fecha_recepcion'
                                    name='fecha_recepcion'
                                    value={ fecha_recepcion }
                                    onChange={ onInputChange }
                                    placeholder='Fecha de Recepción'
                                    type='date'
                                    required
                                />
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup>
                                <label htmlFor="valor_garantia">Valor de Garantía</label>
                                <Input
                                    id='valor_garantia'
                                    name='valor_garantia'
                                    value={ valor_garantia }
                                    onChange={ onInputChange }
                                    placeholder='Valor de Garantía'
                                    type='number'
                                    min="0"
                                    step="0.01"
                                    required
                                />
                          </FormGroup>
                        </Col>
                        <Col md={12}>
                          <FormGroup>
                                <label htmlFor="descripcion_corta">Descripción Corta</label>
                                <Input 
                                    id='descripcion_corta'
                                    name='descripcion_corta'
                                    value={ descripcion_corta }
                                    onChange={ onInputChange }
                                    placeholder='Descripción Corta'
                                    type='text'
                                />
                          </FormGroup>
                        </Col>
                        <Col md={12}>
                          <FormGroup>
                                <label htmlFor="descripcion_larga">Descripción Larga</label>
                                <Input 
                                    id='descripcion_larga'
                                    name='descripcion_larga'
                                    value={ descripcion_larga }
                                    onChange={ onInputChange }
                                    placeholder='Descripción Larga'
                                    type='textarea'
                                />
                          </FormGroup>
                        </Col>

                        {tipoGarantiaSelected === 'VEHICULO' && (
                          <FormGarantiaDetalleVehiculo
                            onInputChange = { onInputChange }
                            placa = { placa }
                            color = { color }
                            modelo = { modelo }
                            marca = { marca }
                          />
                        )}

                      </Row>
                      <Row>
                        <div className='update ml-auto mr-auto'>
                          <Button
                              className='btn-round'
                              color='primary'
                              type='submit'
                          >
                              Guardar
                          </Button>
                          <Button
                              className='btn-round'
                              color='danger'
                              type='button'
                              onClick={handleClickCancelarForm}
                          >
                              Cancelar
                          </Button>
                        </div>
                      </Row>
                    </Form>
                    <Row>
                      {tipoGarantiaSelected === 'BIEN INMUEBLE' && (
                          <FormGarantiaDetalleBienInmueble                       
                            idgarantia = { idgarantia }
                            detalleBienInmueble = { detalleBienInmueble }
                            Swal = { Swal }
                            createDetalleGarantiaBienInmueble = { createDetalleGarantiaBienInmueble }
                            listarDetalleBienInmueble = { listarDetalleBienInmueble }
                            deleteUnSoloDetalleBienInmueble = { deleteUnSoloDetalleBienInmueble }
                          />
                      )}
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </AllowedAccess>
  )
}

export {
  FormGarantia
}
